import { z } from 'zod';

/**
 * Price alerts: "tell me when X crosses Y". Server-checked against the same
 * tick stream the fill engine trades on, so an alert and a fill can never
 * disagree about what the price did. Firing is one-shot — a triggered alert
 * stays in the list as a record and can be re-armed by creating it again.
 */

export const AlertDirectionSchema = z.enum(['above', 'below']);
export type AlertDirection = z.infer<typeof AlertDirectionSchema>;

export const PriceAlertSchema = z.object({
  id: z.string(),
  symbol: z.string(),
  direction: AlertDirectionSchema,
  /** Trigger level, rupees. */
  price: z.number(),
  status: z.enum(['active', 'triggered']),
  createdAt: z.number(),
  triggeredAt: z.number().nullable(),
  /** LTP at the moment it fired (what the user was told). */
  triggeredLtp: z.number().nullable(),
});
export type PriceAlert = z.infer<typeof PriceAlertSchema>;

export const CreateAlertRequestSchema = z.object({
  symbol: z.string().trim().min(1).max(60),
  direction: AlertDirectionSchema,
  price: z.number().positive().max(10_000_000),
});
export type CreateAlertRequest = z.infer<typeof CreateAlertRequestSchema>;

/** Active alerts per user — enough for a serious watcher, bounded for the tick loop. */
export const MAX_ACTIVE_ALERTS = 50;
